<template>
  <section class="location-add">
    <locations :activate-mode="true" />
  </section>
</template>

<script>
import Locations from '../company/Locations.vue';

export default {
  name: 'LocationAdd',
  components: {
    Locations
  }
};
</script>
<style scoped lang="scss">
</style>
